import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CardComponent,
  ChipSelect,
  MatrixTable,
  Minus,
  Tick,
  Tooltip,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import { getProvisionRangeColor } from '../../../core-utils/helper-utils/contractAIQHelper';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import SvgInfo from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Info';
import { Columns as MatrixColumns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/MatrixTable';
import { useStores } from '../../../stores';
import { observer } from 'mobx-react';

export interface CoverageCheckProps {
  data: any[];
   
  handleSort: (fieldName: string) => void;
  sortConfig: {
    fieldName: string;
    direction: 'asc' | 'desc' | null;
  };
  filterOptions?: string[];
  selectedFilterOptions?: string[];
  setSelectedFilterOptions?: React.Dispatch<React.SetStateAction<string[]>>;
  handleAddColumns?: () => void;
}

const useStyles = makeStyles()({
  provisionGrid: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '300px',
  },
  iconWrapper: {
    width: '16px',
    height: '16px',
    marginLeft: '4px',
  },
});

const CoverageCheck: React.FC<CoverageCheckProps> = observer(
  ({
    data,
    handleSort,
    sortConfig,
    filterOptions,
    selectedFilterOptions,
    setSelectedFilterOptions,
    handleAddColumns,
  }) => {
    const { classes } = useStyles();
    const employerGroupStore = useStores().employerGroupStore;

    const getBooleanCell = (value: any) => (
      <div>
        {typeof value === 'boolean' ? (
          value ? (
            <Tick color="#7C98B6" />
          ) : (
            <Minus />
          )
        ) : (
          value
        )}
      </div>
    );
    const defaultMatrixColumns: MatrixColumns[] = [
      {
        header: 'Service Name',
        accessor: 'provision',
        isSortEnabled: true,
        cell: (value: any, row: any) => (
          <div className={classes.provisionGrid}>
            <div>{value}</div>
            {row?.tooltip?.description && (
              <Tooltip
                title={
                  <>
                    <Typography
                      fontSize="13px"
                      lineHeight="19.5px"
                      fontType="semiBold"
                      textColor={patientAccessTheme.palette.status.white}
                    >
                      {row?.tooltip?.description}
                    </Typography>
                    <Typography
                      fontSize="13px"
                      lineHeight="19.5px"
                      fontType="regular"
                      textColor={patientAccessTheme.palette.status.white}
                      margin="8px 0px 0px 0px"
                    >
                      {row?.tooltip?.explaination?.replace(/\?/g, '')}
                    </Typography>
                  </>
                }
                placement="bottom"
              >
                <div className={classes.iconWrapper}>
                  <SvgInfo />
                </div>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        header: 'Favorability Range',
        accessor: 'favorabilityRange',
        cell: (value: any) => (
          <div style={{ color: getProvisionRangeColor(value) }}>{value}</div>
        ),
        align: 'center',
        // isSortEnabled: false,
      },
      {
        header:
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
        accessor: 'value',
        cell: getBooleanCell,
        align: 'center',
      },
    ];

    return (
      <CardComponent
        title={'Overview'}
        subTitle={''}
        width="1100px"
        topRightItem={
          <ChipSelect
            placeholder={'Filter by Category'}
            options={filterOptions || []}
            selectedItems={selectedFilterOptions || []}
            setSelectedItems={setSelectedFilterOptions || (() => {})}
            handleAddColumns={handleAddColumns || (() => {})}
            addButtonLabel="Apply Changes"
          />
        }
        body={
          <Grid style={{ marginTop: '10px' }}>
            <MatrixTable
              columns={defaultMatrixColumns}
              rowsData={data}
              handleSort={handleSort}
              sortConfig={sortConfig}
            />
          </Grid>
        }
      />
    );
  },
);

export default CoverageCheck;
